import React, { useEffect, useState } from "react";
import "./Notification_Create.css";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { AllHosts } from "../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AddHost } from "../../../../features/admin/host/slice";
import {
  AddCustomer,
  GetAllCustomer,
} from "../../../../features/admin/customer/Slice";
import Success_Modal from "../../../common_components/common-modal/success_modal/Success_Modal";
import Reject_Modal from "../../../common_components/common-modal/reject_modal/Reject_Modal";
import { AddNotification } from "../../../../features/admin/notification/Slice";

const Student_Detail_Create = () => {
  const dispatch = useDispatch();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showReject, setShowReject] = useState(false);

  const [showPassword, setShowPassword] = useState({
    password: false,
    confirm: false,
  });

  const navigate = useNavigate();
  const togglePasswordVisibility = (type) => {
    setShowPassword((prev) => ({ ...prev, [type]: !prev[type] }));
  };
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    watch,
  } = useForm({});

  const newPassword = watch("password", "");

  const allHostData = useSelector((state) => state.common.all_hosts);

  useEffect(() => {
    dispatch(AllHosts());
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      const payload = {
        title: data.title,
        message: data.message,
      };

      const res = await dispatch(AddNotification(payload)).unwrap();

      if (res?.success) {
        dispatch(GetAllCustomer());

        setShowSuccess(true);

        setTimeout(() => {
          setShowSuccess(false);
          navigate(-1);
        }, 3000);
      } else {
        setShowReject(true);

        setTimeout(() => {
          setShowReject(false);
        }, 3000);
      }
    } catch (error) {
      console.error("Add Customer Error:", error);

      setShowReject(true);

      setTimeout(() => {
        setShowReject(false);
      }, 3000);
    }
  };

  return (
    <section className="Student_Detail_Create common_section">
      <div className="section_filter_div">
        <p className="filter_title">Create New Notificaion</p>
      </div>
      <div className="host-user-card">
        {" "}
        <div className="form-ro">
          <div className="form-control-wrapper1">
            <button
              type="submit"
              className="submit-btn"
              onClick={() => navigate(-1)}
            >
              Back
            </button>
          </div>
          <br />
        </div>
        <form onSubmit={handleSubmit(onSubmit)} className="form-wrapper-div">
          <div className="form-row">
            <label className="form-label">
              Title <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Title"
                className="form-input"
                {...register("title", {
                  required: "Title is required",
                })}
              />

              {errors.title && (
                <span className="text-danger">{errors.title.message}</span>
              )}
            </div>
          </div>
          <div className="form-row">
            <label className="form-label">
              Message <span>*</span>
            </label>

            <div className="form-control-wrapper">
              <input
                type="text"
                placeholder="Message"
                className="form-input"
                {...register("message", {
                  required: "Message is required",
                })}
              />

              {errors.message && (
                <span className="text-danger">{errors.message.message}</span>
              )}
            </div>
          </div>{" "}
          <div className="form-row">
            <div className="form-label"></div>

            <div className="form-control-wrapper">
              <button type="submit" className="submit-btn">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      <Success_Modal
        show={showSuccess}
        onHide={() => {
          setShowSuccess(false);
          navigate(-1);
        }}
      />{" "}
      <Reject_Modal
        show={showReject}
        onHide={() => {
          setShowReject(false);
          navigate(-1);
        }}
      />
    </section>
  );
};

export default Student_Detail_Create;
